/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import './Billingpage.scss'
import {
  GetLowCreditAlertSmsData,
  UpdateLowCreditAlertSmsData,
  updateAutotopup,
} from './BillingSlice/BillingSlice'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import Select from 'react-select/creatable'
import {object} from 'yup'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {
  AutoRefillValidation,
  LowCreditValidation,
} from '../../../../Utils/_helpers/ValidationSchema'
import {useLocation, useNavigate} from 'react-router-dom'
import {isLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {useGetCardsQuery} from '../../../../../services/cellcast'
import StripeJSProvider from '../../../../Utils/StripeJSProvider'
import {Elements} from '@stripe/react-stripe-js'
import CardAddPopup from '../../../Common/modal/CardAddPopup'
import {toNumber} from 'lodash'
const BillingAddress = () => {
  const dispatch = useDispatch()
  const generalLoading = useSelector(isLoading)
  const navigate = useNavigate()

  const location = useLocation()
  const ref = useRef<HTMLDivElement | null>(null)

  const thresholdData = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.threshold
  )
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const getLowcreditData = useSelector((state: any) => state?.PurchaseHistory?.lowCreditData)

  const [lowCreditAlertError, setLowCreditAlertError] = useState({
    email: '',
    mobile: '',
    emailNotification: false,
    mobileNotification: false,
    smsCredit: '',
    mmsCredit: '',
    alertType: [],
  })

  const [data, setData] = useState<any>({
    autoTopupSms: false,
    autoTopupMms: false,
    smsCredit: 0,
    smsThreshold: '',
    mmsCredit: 0,
    mmsThreshold: '',
  })

  const [card, setCard] = useState(false)
  const [noOfCredit, setNoOFCredit] = useState<any>(0)
  const [checkBox, setCheckBox] = useState(false)

  useEffect(() => {
    setData({...thresholdData})
  }, [thresholdData])
  useEffect(() => {
    AuthenticateUser('low-credit-notification-settings') && dispatch(GetLowCreditAlertSmsData())
  }, [])
  useEffect(() => {
    const params = {
      ...getLowcreditData,
      alertType:
        getLowcreditData?.alertType == 'both' ? ['mobile', 'email'] : [getLowcreditData?.alertType],
      mobile: getLowcreditData?.phone,
      email: getLowcreditData?.email,
      smsCredit: getLowcreditData?.lowThreshold || 0,
      mmsCredit: getLowcreditData?.lowThreshold || 0,
    }

    if (getLowcreditData?.smsThreshold) {
      params.smsCredit = getLowcreditData?.smsThreshold
    }

    if (getLowcreditData?.mmsThreshold) {
      params.mmsCredit = getLowcreditData?.mmsThreshold
    }

    setLowCreditAlertError(params)
  }, [getLowcreditData])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const scrollId = queryParams.get('scrollId')
    if (scrollId && scrollId === 'auto-fill' && ref.current != null) {
      const timeout = setTimeout(() => {
        if (ref.current) {
          ref.current.scrollIntoView({behavior: 'smooth'})
        }
      }, 500)
      return () => clearTimeout(timeout)
    }
  }, [location.search, generalLoading])

  const {data: cards, isLoading: cardsLoading, refetch: refetchGetCards} = useGetCardsQuery()

  const restAllData = () => {
    setCheckBox(false)
    setCard(false)
    setNoOFCredit(0)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10' ref={ref}>
        <div className='card-header align-items-center'>
          <div className='card-title'>
            <h3 className='fs-2'>Auto top up</h3>
          </div>
          <a href='#' className='fs-6 fw-bold'>
            See rate card
          </a>
        </div>
        <div className='card-body'>
          <div className='row'>
            <img
              alt=''
              className='mb-10'
              src={toAbsoluteUrl('/media/misc/auto-refill-chart.png')}
            />
          </div>
          <Formik
            enableReinitialize
            initialValues={data}
            validationSchema={AutoRefillValidation}
            onSubmit={(values, {setSubmitting}) => {
              dispatch(updateAutotopup(values))
            }}
          >
            {({values, setFieldValue, errors}) => (
              <Form>
                {/* Your form content here */}
                <div className='row mt-8'>
                  <div className='col-12'>
                    <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                      <div className='custom-btn-wrapper'>
                        <label className='custom-checkbox mb-4'>
                          Auto top-up SMS
                          <Field data-testid='cbAutoTopUpSMS' type='checkbox' name='autoTopupSms' />
                          <span className='checkmark'></span>
                        </label>
                        <ErrorMessage name='autoTopupSms' component='div' className='error' />
                      </div>
                    </div>
                    {values.autoTopupSms && (
                      <div className='row'>
                        <div className='col-12'>
                          <div className='auto-fill-inner'>
                            <div className='dropdown-wrapper' data-testid='ddSMSTopUp'>
                              <h5>Automatically add</h5>

                              <Select
                                className='form-control bg-light border-0 select-arrow'
                                value={{
                                  value: values?.smsCredit ?? 0,
                                  label: `${values?.smsCredit ?? 0} Credit`,
                                }}
                                name='smsCredit'
                                onChange={(e: any) => setFieldValue('smsCredit', e.value)}
                                options={[
                                  {value: 20, label: '20 Credit'},
                                  {value: 50, label: '50 Credit'},
                                  {value: 100, label: '100 Credit'},
                                  {value: 250, label: '250 Credit'},
                                  {value: 500, label: '500 Credit'},
                                  {value: 1000, label: '1000 Credit'},
                                  {value: 5000, label: '5000 Credit'},
                                  {value: 10000, label: '10000 Credit'},
                                  {value: 20000, label: '20000 Credit'},
                                  {value: 100000, label: '100000 Credit'},
                                  {value: 200000, label: '200000 Credit'},
                                  {value: 300000, label: '300000 Credit'},
                                  {value: 400000, label: '400000 Credit'},
                                  {value: 500000, label: '500000 Credit'},
                                  {value: 1000000, label: '1000000 Credit'},
                                ]}
                              />
                            </div>
                            <div className='arrow-wrapper'>
                              <svg
                                width='33'
                                height='16'
                                viewBox='0 0 33 16'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M1 7C0.447715 7 4.82823e-08 7.44772 0 8C-4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM32.7071 8.70711C33.0976 8.31659 33.0976 7.68342 32.7071 7.2929L26.3431 0.928934C25.9526 0.53841 25.3195 0.53841 24.9289 0.928934C24.5384 1.31946 24.5384 1.95262 24.9289 2.34315L30.5858 8L24.9289 13.6569C24.5384 14.0474 24.5384 14.6805 24.9289 15.0711C25.3195 15.4616 25.9526 15.4616 26.3431 15.0711L32.7071 8.70711ZM1 9L32 9L32 7L1 7L1 9Z'
                                  fill='#7950f2'
                                />
                              </svg>
                            </div>
                            <div className='dropdown-wrapper'>
                              <h5>When balance is below</h5>
                              <Field
                                data-testid='inputSMSThreshold'
                                className='form-control bg-light border-0'
                                type='number'
                                name='smsThreshold'
                              />
                              <ErrorMessage
                                name='smsThreshold'
                                component='div'
                                className='error text-danger'
                              />
                            </div>
                            {/* Other components */}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='col-12'>
                    <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'>
                      <div className='custom-btn-wrapper'>
                        <label className='custom-checkbox mb-4'>
                          Auto top-up MMS
                          <Field data-testid='cbAutoTopUpMMS' type='checkbox' name='autoTopupMms' />
                          <span className='checkmark'></span>
                        </label>
                        <ErrorMessage name='autoTopupMms' component='div' className='error' />
                      </div>
                    </div>
                    {values.autoTopupMms && (
                      <div className='row'>
                        <div className='col-12'>
                          <div className='auto-fill-inner'>
                            <div className='dropdown-wrapper' data-testid='ddMMSTopUp'>
                              <h5>Automatically add</h5>

                              <Select
                                className='form-control bg-light border-0 select-arrow'
                                value={{
                                  value: values?.mmsCredit ?? 0,
                                  label: `${values?.mmsCredit ?? 0} Credit`,
                                }}
                                name='mmsCredit'
                                onChange={(e: any) => setFieldValue('mmsCredit', e.value)}
                                options={[
                                  {value: 20, label: '20 Credit'},
                                  {value: 50, label: '50 Credit'},
                                  {value: 100, label: '100 Credit'},
                                  {value: 250, label: '250 Credit'},
                                  {value: 500, label: '500 Credit'},
                                  {value: 1000, label: '1000 Credit'},
                                  {value: 5000, label: '5000 Credit'},
                                  {value: 10000, label: '10000 Credit'},
                                  {value: 20000, label: '20000 Credit'},
                                  {value: 100000, label: '100000 Credit'},
                                  {value: 200000, label: '200000 Credit'},
                                ]}
                              />
                            </div>
                            <div className='arrow-wrapper'>
                              <svg
                                width='33'
                                height='16'
                                viewBox='0 0 33 16'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M1 7C0.447715 7 4.82823e-08 7.44772 0 8C-4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM32.7071 8.70711C33.0976 8.31659 33.0976 7.68342 32.7071 7.2929L26.3431 0.928934C25.9526 0.53841 25.3195 0.53841 24.9289 0.928934C24.5384 1.31946 24.5384 1.95262 24.9289 2.34315L30.5858 8L24.9289 13.6569C24.5384 14.0474 24.5384 14.6805 24.9289 15.0711C25.3195 15.4616 25.9526 15.4616 26.3431 15.0711L32.7071 8.70711ZM1 9L32 9L32 7L1 7L1 9Z'
                                  fill='#7950f2'
                                />
                              </svg>
                            </div>
                            <div className='dropdown-wrapper'>
                              <h5>When balance is below</h5>
                              <Field
                                data-testid='inputMMSThreshold'
                                className='form-control bg-light border-0'
                                type='number'
                                name='mmsThreshold'
                              />
                              <ErrorMessage
                                name='mmsThreshold'
                                component='div'
                                className='error text-danger'
                              />
                            </div>
                            {/* Other components */}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {cardsLoading || (
                  <div className='row mt-2 p-4'>
                    {AuthenticateUser('create-auto-popup-setting') && (
                      <div className='col-md-12'>
                        {cards?.data?.length < 1 && (
                          <p className='title-h2 text-danger'>
                            No card added yet, to enable auto top-up please add a card first.
                          </p>
                        )}
                        <div
                          className='ml-3 btn btn-primary fw-500'
                          onClick={() => {
                            setCard(true)
                          }}
                        >
                          {cards?.data?.length < 1 ? 'Add Card' : 'List Card'}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Submit button */}
                {cardsLoading || (
                  <div className='row border-top mt-2 p-4'>
                    <div className='col-md-12 text-center text-md-end'>
                      {AuthenticateUser('create-auto-popup-setting') && (
                        <button
                          data-testid='btnSaveChangesAutoTopUp'
                          type='submit'
                          className='btn btn-primary fw-500'
                          disabled={cards?.data?.length < 1}
                        >
                          Save Change
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Formik>

          <StripeJSProvider>
            {({stripe}: any) =>
              stripe ? (
                <Elements stripe={stripe}>
                  <CardAddPopup
                    restData={() => restAllData()}
                    show={card}
                    handleClose={() => {
                      setCard(false)
                      setCheckBox(false)
                      setCard(false)
                      setNoOFCredit(0)
                      refetchGetCards()
                    }}
                    customData={{
                      credits: !checkBox ? +noOfCredit : Math.ceil(+noOfCredit + +noOfCredit * 0.3),
                    }}
                    couponId={null}
                  />
                </Elements>
              ) : null
            }
          </StripeJSProvider>
        </div>
      </div>

      {AuthenticateUser('low-credit-notification-settings') && (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-header'>
            <div className='card-title'>
              <h3 className='fs-2'>Low credit alert</h3>
            </div>
          </div>
          <div className='card-body'>
            <Formik
              enableReinitialize
              initialValues={lowCreditAlertError}
              validationSchema={LowCreditValidation}
              onSubmit={(value: any) => {
                const params = {
                  alertType: value?.alertType?.length == 2 ? 'both' : value?.alertType?.[0],
                  email: value?.email,
                  phone: value?.mobile,
                  smsThreshold: toNumber(value?.smsCredit),
                  mmsThreshold: toNumber(value?.mmsCredit),
                }

                if (!params?.alertType) {
                  if (params.email && params.email.length > 0) {
                    params.alertType = 'email'
                  }

                  if (params.phone && params.phone.length > 0) {
                    params.alertType = 'mobile'
                  }

                  if (
                    params.email &&
                    params.email.length > 0 &&
                    params.phone &&
                    params.phone.length > 0
                  ) {
                    params.alertType = 'both'
                  }
                }

                dispatch(UpdateLowCreditAlertSmsData(params))
              }}
            >
              {({isSubmitting, values, errors, touched, isValid}) => (
                <Form>
                  <div className='first-row'>
                    <div className='row align-items-center'>
                      <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                        <h5 className='title-h5'>Alert type:</h5>
                      </div>
                      <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                        <div className='check-btn'>
                          <div className='custom-btn-wrapper'>
                            <label className='custom-checkbox'>
                              Email
                              <Field
                                data-testid='cbEmailAlert'
                                type='checkbox'
                                name='alertType'
                                value='email'
                              />
                              <span className='checkmark'></span>
                            </label>
                          </div>
                          <div className='custom-btn-wrapper'>
                            <label className='custom-checkbox'>
                              SMS
                              <Field
                                data-testid='cbSMSAlert'
                                type='checkbox'
                                name='alertType'
                                value='mobile'
                              />
                              <span className='checkmark'></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='row align-items-center mb-5'>
                    <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                      <h5 className='title-h5'>Email address</h5>
                    </div>
                    <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                      <Field
                        data-testid='inputEmailLowCreditAlert'
                        className='form-control bg-light border-0'
                        name='email'
                        placeholder='for multiple email separate by ;'
                      />
                      {touched.email && errors.email && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert' className='text-danger'>
                              {errors.email}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='row align-items-center mb-5'>
                    <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                      <h5 className='title-h5'>Phone number</h5>
                    </div>
                    <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                      <Field
                        data-testid='inputPhoneLowCreditAlert'
                        className='form-control bg-light border-0'
                        type='text'
                        name='mobile'
                      />
                      {touched.mobile && errors.mobile && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert' className='text-danger'>
                              {errors.mobile}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row align-items-center mb-5'>
                    <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                      <h5 className='title-h5'>Alert when sms credits go below</h5>
                    </div>
                    <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                      <Field
                        data-testid='inputLowCreditAlertThreshold'
                        className='form-control bg-light border-0'
                        type='text'
                        name='smsCredit'
                      />
                      {touched.smsCredit && errors.smsCredit && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert' className='text-danger'>
                              {errors.smsCredit}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row align-items-center mb-5'>
                    <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                      <h5 className='title-h5'>Alert when mms credits go below</h5>
                    </div>
                    <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                      <Field
                        data-testid='inputLowCreditAlertThreshold'
                        className='form-control bg-light border-0'
                        type='text'
                        name='mmsCredit'
                      />
                      {touched.mmsCredit && errors.mmsCredit && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert' className='text-danger'>
                              {errors.mmsCredit}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row border-top mt-2 p-4'>
                    <div className='col-md-12 text-center text-xl-end text-lg-end text-md-end'>
                      {/* <button className='btn btn-light btn-active-light-primary me-2 fw-500'>
                      Discard
                    </button> */}
                      <button
                        data-testid='btnSubmitLowCreditAlert'
                        className='btn btn-primary fw-500'
                        type='submit'
                        disabled={!isValid || values?.alertType?.length == 0}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  )
}

export default BillingAddress
